import { render, staticRenderFns } from "./vchRfpMctb.vue?vue&type=template&id=cd8cd0f8"
import script from "./vchRfpMctb.vue?vue&type=script&lang=js"
export * from "./vchRfpMctb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports